__turbopack_context__.v({
  "csLink": "Feedback-module__xFE4hG__csLink",
  "submittedContainer": "Feedback-module__xFE4hG__submittedContainer",
  "submittedContent": "Feedback-module__xFE4hG__submittedContent",
});
